import { render, staticRenderFns } from "./areaPasswordForgottenActivation.vue?vue&type=template&id=05cde95a&scoped=true"
import script from "./areaPasswordForgottenActivation.vue?vue&type=script&lang=js"
export * from "./areaPasswordForgottenActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cde95a",
  null
  
)

export default component.exports